<template>
  <div class="email-container container">
    <div class="container-header">
      <p>
        {{$t('emailPage.mainTitle[0]')}}
      </p>
      <p>
        {{$t('emailPage.mainTitle[1]')}}
      </p>
    </div>
    <div class="content">
      <div class="content-header">
        <p>
          訂購日期及時間 : 21/02/2020 20:11
        </p>
        <p>
          付款方式 : VISA - Online
        </p>
        <a-table
          :columns="columns"
          :data-source="data"
          :pagination="false"
        >
          <span
            slot="price"
            slot-scope="price"
          >
            <span v-if="price > 0">
              ${{price}}
            </span>
            <span v-else>
              -${{Math.abs(price)}}
            </span>
          </span>
        </a-table>
      </div>
    </div>
    <div class="container-footer">
      <div class="footer-top">
        <p>
          If you have any questions, contact us at <a href="#">info@rabbitzhop.com.hk</a>
        </p>
        <p>
          Something wrong with the email? <a href="#">View it in your browser</a>.
        </p>
      </div>
      <div class="footer-bottom">
        You're receiving this email because you made a purchase at rabbitzhop, which partners with Stripe to provide invoicing and payment processing.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      columns: [
        {
          title: '商品詳情 Description',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '數量',
          dataIndex: 'number',
          key: 'age',
        },
        {
          title: '	金額',
          key: 'price',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
        }
      ], data: [
        {
          key: '1',
          name: 'MUJI GIFT$100 禮品卡',
          number: 1,
          price: 50,
        },
        {
          key: '2',
          name: 'MUJI GIFT$100 禮品卡',
          number: 1,
          price: 50,
        },
        {
          key: '3',
          name: `${this.$t('cart.discounted')}: 99999`,
          number: this.$t('cart.discount'),
          price: -10
        },
        {
          key: '4',
          number: this.$t('cart.totalPrice'),
          price: 90
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.container-header {
  padding-top: 20px;
  text-align: left;
}
.content {
  padding: 25px 30px;
  background-color: #f8f8f8;
  .content-header {
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    padding: 5px 10px;
  }
}

::v-deep .ant-table-body {
  .ant-table-thead > tr > th {
    background-color: #fff;
  }
  .ant-table-thead > tr > th:nth-child(n + 2),
  .ant-table-tbody > tr > td:nth-child(n + 2) {
    white-space: nowrap;
    text-align: center;
  }
  .ant-table-tbody > tr:last-of-type > td {
    border-bottom: none;
  }
}

.container-footer {
  text-align: left;
  .footer-top {
    padding-bottom: 20px;
    margin: 30px 0;
    border-bottom: 1px dashed #ccc;
    a {
      color: #0f96bb;
      text-decoration: underline;
    }
  }
}
</style>